import { PhysicianInfo } from 'types';

export const computePhysicianFullName = (physician: PhysicianInfo, { withCredentials = false }) => {
  return withCredentials
    ? `${physician.firstName} ${physician.lastName}, ${physician.credentials}`
    : `${physician.firstName} ${physician.lastName}`;
};
